import { render, staticRenderFns } from "./ServiceFeeApplication.vue?vue&type=template&id=49bb42ba&"
import script from "./ServiceFeeApplication.vue?vue&type=script&lang=js&"
export * from "./ServiceFeeApplication.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports